<template>
    <header class="">
        <h1>
            <a href="" class="icon_wrap">
                <img src="img/logo.png" alt="디지털 성매매 시민참여 플랫폼 관리자" />
            </a>
        </h1>
    </header>
</template>

<script lang="ts">
    import {
        apiService,
        onMounted,
        reactive,
        router,
        userStore,
        returnCode,
        globalStore,
        watch,
        types,
        useRoute,
        ref,
        onUnmounted,
    } from "@/BaseComponent";

    export default {
        components: {},
        setup() {
            const user = userStore();
            const route = useRoute();
            const global = globalStore();
            const { changeCode } = returnCode();

            const userInfo = reactive({
                info: {} as any,
                password: "" as string,
                password_ck: "" as string,
                name: user.userInfo?.name as string,
                id: user.userInfo?.id as string,
            });
            const state = reactive({
                searchDate: [] as any,
                userMenu: false,
                settingMenu: false,
                isModalOpen: false,
                isUserModal: false,
                isKeywordModal: false,
                isHelperModal: false,
                position: [] as any,
                dept: [] as any,
                isLogin: false as boolean,
                isFloat: false as boolean,

                menuOverFlag: false as boolean,
                headerClass: [] as Array<string>,
                isScroll: false as boolean,
            });

            const modal = reactive({
                title: "",
                customClass: {
                    wrap: [] as Array<string>,
                    button: [] as Array<string>,
                },
                list: [] as any,
                fields: [] as any,
                cancel: "",
                confirm: "",
                type: "nation",
                actionCode: 0 as number,
                isBtn: true as boolean,
            });

            const scrollY = ref(0);

            onMounted(async () => {
                checkLogin();
                window.addEventListener("scroll", handleScroll);

                state.headerClass = route.meta.headerClass as string[];
            });

            onUnmounted(() => {
                window.removeEventListener("scroll", handleScroll);
            });

            watch(
                () => user.accessToken,
                () => {
                    checkLogin();
                },
            );

            const handleScroll = () => {
                scrollY.value = window.scrollY;

                if (scrollY.value >= 100) {
                    state.isScroll = true;
                } else {
                    state.isScroll = false;
                }
            };

            const checkLogin = () => {
                if (user.isLogin()) {
                    state.isLogin = true;
                } else {
                    state.isLogin = false;
                }
            };

            const handleOutsideClick = () => {
                state.userMenu = false;
            };

            const handleOutsideClick2 = () => {
                state.settingMenu = false;
            };

            const logout = async () => {
                if (user && user.accessToken != null && user.accessToken != "") {
                    let res: types.BaseResponse = await apiService.auth.logout();

                    if (res !== null && res.returnCode === 0) {
                        state.isLogin = false;
                        user.$reset();
                        router.replace("/");
                    } else {
                        state.isLogin = true;
                    }
                }
            };

            const openMenu = (menuIdx: number) => {
                switch (menuIdx) {
                    case 0:
                        state.userMenu = !state.userMenu;
                        state.settingMenu = false;
                        break;
                    case 1:
                        state.settingMenu = !state.settingMenu;
                        state.userMenu = false;
                        break;
                }
            };

            return {
                state,
                userInfo,
                modal,
                openMenu,
                logout,
                router,
                handleOutsideClick,
                handleOutsideClick2,
                user,
            };
        },
    };
</script>
